// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tqZ7","question":"styles_question__3CYUw","description":"styles_description__D4kGt"};